import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import rabbitImage from '../assets/images/white-rabbit.png';

const SplashScreen = ({ onCompleted }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    if (isAnimating) return;
    setIsAnimating(true);
  };

  useEffect(() => {
    if (isAnimating) {
      const completeTimer = setTimeout(() => {
        onCompleted();
      }, 1200); // Match animation duration

      return () => clearTimeout(completeTimer);
    }
  }, [isAnimating, onCompleted]);

  return (
    <SplashContainer onClick={handleClick}>
      <RabbitButton isAnimating={isAnimating}>
        <img src={rabbitImage} alt="White Rabbit" />
      </RabbitButton>
      <FollowText isAnimating={isAnimating}>Follow the white rabbit</FollowText>
    </SplashContainer>
  );
};

const pulse = keyframes`
  0% { transform: scale(1); filter: drop-shadow(0 0 5px var(--primary-color)); }
  50% { transform: scale(1.05); filter: drop-shadow(0 0 15px var(--primary-color)); }
  100% { transform: scale(1); filter: drop-shadow(0 0 5px var(--primary-color)); }
`;

const scanline = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 0 100%; }
`;

const rabbitZoom = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: scale(50) rotate(360deg);
    opacity: 0;
  }
`;

const textFade = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const SplashContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: pointer;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06));
    background-size: 100% 4px, 6px 100%;
    animation: ${scanline} 20s linear infinite;
  }
`;

const RabbitButton = styled.div`
  background: transparent;
  border: none;
  padding: 0;
  
  img {
    width: 200px;
    animation: 
      ${({ isAnimating }) => isAnimating 
        ? css`${rabbitZoom} 1.2s forwards ease-in` 
        : css`${pulse} 2s infinite ease-in-out`};
  }
`;

const FollowText = styled.p`
  color: var(--primary-color);
  font-family: 'VT323', monospace;
  font-size: 2rem;
  margin-top: 2rem;
  text-shadow: 0 0 5px var(--primary-color);
  pointer-events: none;
  opacity: ${({ isAnimating }) => (isAnimating ? 0 : 1)};
  transition: opacity 0.5s ease-in-out;
`;

export default SplashScreen; 